import CurrencyInput from "react-currency-input";

function InputMoney({
  value,
  onChange,
  ...props
}: {
  value: any;
  onChange: any;
} & any) {
  return (
    <CurrencyInput
      value={value}
      decimalSeparator=","
      thousandSeparator="."
      placeholder="0,00"
      style={{
        textAlign: "right",
      }}
      onChangeEvent={(_values: any, _val: any, floatValue: number) => {
        onChange(floatValue);
      }}
      {...props}
    />
  );
}

export default InputMoney;
